import React from "react";
import { SharedDrive } from "~/gql/types2";
import DropdownFormField from "../DropdownFormField";

const mapDriveOptions = (
  driveOptions: SharedDrive[]
): { label: string; value: string }[] => {
  const baseOptions = driveOptions.map((drive) => ({
    label: `${drive.driveLetter}:\\ (best for access from the ${drive.physicalLocation} location)`,
    value: drive.driveLetter,
  }));

  const options = [{ label: "none", value: "" }, ...baseOptions];

  return options;
};

type SharedDrivePickerFormFieldProps = {
  sharedDriveOptions: SharedDrive[];
  label: string;
  formField: string;
  loading: boolean;
};

export const SharedDrivePickerFormField: React.FC<
  SharedDrivePickerFormFieldProps
> = ({ sharedDriveOptions, label, formField, loading }) => {
  const options = mapDriveOptions(sharedDriveOptions);

  return (
    <DropdownFormField
      label={label}
      formField={formField}
      helperText=""
      options={options}
      loading={loading}
    />
  );
};
